import React from 'react';
import { BurstParticle } from '../../services/particleEffectsService';

interface BurstParticlesProps {
  particles: BurstParticle[];
  containerSize?: number; // If provided, use for scaling, else use window size
  zIndex?: number;
}

const BurstParticles: React.FC<BurstParticlesProps> = ({ particles, containerSize = 0, zIndex = 97 }) => {
  // If containerSize is 0, use window size
  const width = containerSize || window.innerWidth;
  const height = containerSize || window.innerHeight;

  return (
    <>
      {particles.map(particle => {
        const progress = particle.life / particle.maxLife;
        const opacity = Math.sin(Math.PI * (1 - progress)) * 0.7;
        const scale = 0.5 + Math.sin(Math.PI * progress) * 0.5;
        return (
          <div
            key={particle.id}
            style={{
              position: 'absolute',
              left: particle.x * width,
              top: particle.y * height,
              transform: `translate(-50%, -50%) scale(${scale}) rotate(${particle.rotation}deg)`,
              width: '8px',
              height: '8px',
              background: particle.color,
              borderRadius: '50%',
              opacity,
              pointerEvents: 'none',
              zIndex,
              boxShadow: `0 0 6px ${particle.color}`,
            }}
          />
        );
      })}
    </>
  );
};

export default BurstParticles;
